import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { KanbanPage } from '@/features/kanban/components/KanbanPage'

export const Route = createFileRoute('/_auth/kanban')({
  validateSearch: (search: Record<string, unknown>): { pipeline?: string } => ({
    pipeline: typeof search.pipeline === 'string' ? search.pipeline : undefined,
  }),
  component: KanbanRoute,
})

// eslint-disable-next-line react-refresh/only-export-components
function KanbanRoute() {
  const { pipeline } = Route.useSearch()
  const navigate = useNavigate()

  return (
    <KanbanPage
      key={pipeline ?? 'default'}
      initialPipelineId={pipeline}
      onPipelineChange={(pipelineId) => {
        void navigate({
          to: '/kanban',
          search: { pipeline: pipelineId },
          replace: true,
        })
      }}
    />
  )
}
